import React from "react";
import { Trades } from "../../../data/domestic/trades/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { DisplayBoolNumber } from "../../components/common/DisplayBoolNumber";
import { Status } from "../../../data/models";

export interface DisplayTradeMainAttributesProps {
	trade: Trades;
}

export const DisplayTradeMainAttributes: React.FunctionComponent<DisplayTradeMainAttributesProps> = ({
	trade,
}) => {
	const style = useDisplaySingleEmementStyles();
	const { getString, getDateTimeString, getDateString, getFormatedNumberString, getFormatedNumberString4 } = React.useContext(LocalizationContext);
	

	return (
		<div className={style.root}>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeNo")}</span>
				<span className={style.value}>{trade.clTradeId}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeDescr")}</span>
				<span className={style.value}>{trade.tranDesc}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("paymentDataTime")}</span>
				<span className={style.value}>{getDateTimeString(trade.tradeTime)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeSettl")}</span>
				<span className={style.value}>{getDateString(trade.settlDate, "DD.MM.YYYY")}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeSecurity")}</span>
				<span className={style.value}>{trade.symbol}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeCurrCode")}</span>
				<span className={style.value}>{trade.currency}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeQty")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.qty)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradePrice")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.price, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeAmt")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.tradeAmt, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeBrokCommPerc")}</span>
				<span className={style.value}> {`${getFormatedNumberString(trade.brokCommPerc, true)} %`}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradebrokCommAmt")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.brokCommAmt, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeExchCommAmt")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.exchCommAmt, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeBankCommPerc")}</span>
				<span className={style.value}> {`${getFormatedNumberString(trade.bankCommPerc, true)} %`}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeBankCommAmt")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.bankCommAmt, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeTotComm")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.totComm, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeAmtFinal")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.totAmt, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("orderSecurityAcc")}</span>
				<span className={style.value}>{trade.securityAcc}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("orderMoneyAcc")}</span>
				<span className={style.value}>{trade.moneyAcc}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("currCodeSettl")}</span>
				<span className={style.value}>{trade.settlCurrency}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("tradeRate")}</span>
				<span className={style.value}> {getFormatedNumberString4(trade.rate, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("amountSettl")}</span>
				<span className={style.value}> {getFormatedNumberString(trade.settlAmt, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
		        <span className={style.label}>{getString("settlState")}</span>
        		<span className={style.value}>
		          <DisplayBoolNumber
        		    value={trade.settlStat}
		            thrutyValue={Status.Active}
        		    className={style.icon}
		          />
        		</span>
		    </div>
		</div>
	);
};
